module.exports = __webpack_public_path__ + "static/media/logo-1.7fd00863.png";